module.exports = __webpack_public_path__ + "img/clients.e6690be6.svg";